import PropTypes from 'prop-types'
import theme from '../../constants/theme'

const SuccessIcon = ({ color = theme.success, style, ...props }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth={2.5}
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ width: '45%', height: '45%', color, ...style }}
    {...props}
  >
    <polyline points="20 6 9 17 4 12" />
  </svg>
)

SuccessIcon.propTypes = {
  color: PropTypes.string,
  style: PropTypes.object,
}

export default SuccessIcon
